import {
  ListButton,
  ReviewsServiceName
} from "@bluframe/mightychroma-mightytool-frontend-types"
import { Props as ReviewsProps } from "components/HomeVideoReviews/Reviews"
import { memo } from "react"

import { Props as ActionProps } from "./Actions"
import Main, { ServiceSection } from "./Main"

export interface Props {
  readonly actionsPropsByService: Record<
    ReviewsServiceName,
    Omit<ActionProps, "isAdmin" | "isEditor">
  >
  readonly clearAllListsButtonProps: ListButton
  readonly isAdmin: boolean
  readonly isEditor: boolean
  readonly listAllButtonProps: ListButton
  readonly reviewsPropsByService: Record<
    ReviewsServiceName,
    Omit<ReviewsProps, "actions">
  >
  readonly services: ServiceSection[]
}

export interface ComponentProps extends Props {}

export default memo(Main)
